import {Construct} from './construct';
import {TranslatedText} from 'shared/models/translated-text';

export class Question {
  public _id: number;
  public text: {
    de: string;
    en: string;
  };
  public answerType: number;
  public constructId: number;
  public construct: Construct;
  public dialogId: number;
  public minLabel?: Dictionary<string>;
  public maxLabel?: Dictionary<string>;
  public options?: Array<TranslatedText>;
  public solution?: string;
  public varName?: string;

  constructor(id?: number) {
    this._id = id;
    this.text = {de: '', en: ''};
    this.construct = new Construct();
  }

  public static create(data: Question): Question {
    const question: Question = new Question(data._id);
    question.text = data.text;
    question.answerType = data.answerType;
    question.constructId = data.constructId;
    question.dialogId = data.dialogId;
    if (data.minLabel) {
      question.minLabel = data.minLabel;
    }
    else if (data.answerType == 1 || data.answerType == 2) {
      question.minLabel  = {};
    }
    if (data.maxLabel) {
      question.maxLabel = data.maxLabel;
    }
    else if (data.answerType == 1 || data.answerType == 2) {
      question.maxLabel  = {};
    }

    if (data.solution) {
      question.solution = data.solution;
    }

    if (data.varName) {
      question.varName = data.varName;
    }

    if (data.construct) {
      question.construct = data.construct;
    }

    if (data.options) {
      question.options = data.options;
    }

    return question;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/classes/question.ts